// extracted by mini-css-extract-plugin
export default {"line":"table_line__2BWix","label":"table_label__F4xHa"};